import { render, staticRenderFns } from "./volunteerTemplate.vue?vue&type=template&id=adc83860&scoped=true"
import script from "./volunteerTemplate.vue?vue&type=script&lang=js"
export * from "./volunteerTemplate.vue?vue&type=script&lang=js"
import style0 from "./volunteerTemplate.vue?vue&type=style&index=0&id=adc83860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc83860",
  null
  
)

export default component.exports